
import { useEffect, useState } from "react";
import Sider from "../../comps/sider/main";
import './main.css';
import { Link, useSearchParams } from 'react-router-dom';
import callAPI from "../../comps/fetch/main";
import ShowPlans from "../../comps/show_plans/main";
import { Alert, Skeleton, Card, message, Col, Row, Statistic, Tooltip, Empty, Button, Collapse, Popover, Divider, Modal, Segmented, Tag, Space, Tabs, Select, FloatButton, Progress, Flex } from "antd";
import { RightCircleOutlined, VideoCameraOutlined, HistoryOutlined, PlusSquareOutlined, PlusCircleOutlined, StepForwardOutlined, FastForwardOutlined, BranchesOutlined, FilterOutlined, FilterTwoTone, InstagramOutlined, YoutubeOutlined, CommentOutlined } from '@ant-design/icons';
import { useLocation, useNavigate } from "react-router-dom";
import AccessOrNot from "../../funcs/accessOrNot";
import AutomationList from "../automationList/main";
import WhatsNew from "../../comps/whatsNew/main";
// import { PhoneMockup } from "react-daisyui";

function Home() {

  const [searchParams] = useSearchParams();
  let default_tab = searchParams.get("tab");
  default_tab = default_tab || "1"

  const navigate = useNavigate();
  const [loading, setLoading] = useState()
  const [data, setData] = useState()
  const { Meta } = Card;
  const [loadingAutomated, setLoadingAutomated] = useState()
  const [dataAutomated, setDataAutomated] = useState({ data: undefined })

  const [dataAutomatedFormated, setDataAutomatedFormated] = useState({})
  const [loadMore, setLoadMore] = useState(false)

  const [oldData, setOldData] = useState([])
  const [messageApi, contextHolder] = message.useMessage();

  const [postsError, setPostsError] = useState(undefined)

  const [totalCredits, setTotalCredits] = useState()

  let user_tz = Intl.DateTimeFormat().resolvedOptions().timeZone

  const [userUsage, setUserUsage] = useState({ "monthly_count": "" })
  const [accountViral, setAccountViral] = useState({})
  const [loadingUserUsage, setLoadingUserUsage] = useState(true)

  const [selectedCategory, setSelectedCategory] = useState('posts')

  const [showPlanModal, setShowPlanModal] = useState(false)

  const [statusError, setStatusError] = useState(false)

  const [trailActive, setTrailActive] = useState(8)

  const [filterPosts, setFilterPosts] = useState("all")

  useEffect(() => {

    if (!filterPosts || filterPosts == "all") {
      return
    }



    // setData()

  }, [filterPosts])

  useEffect(() => {
    const token = localStorage.getItem("token")
    if (token == undefined) {

      navigate("/signup")
    }
    setLoadMore(true)
  }, [])

  useEffect(() => {
    if (postsError != undefined) {
      messageApi.open({
        type: 'error',
        content: postsError,
        duration: 15,
        key: 2
      })
    }
  }, [postsError])

  useEffect(() => {


    if (loadingUserUsage == true) {
      return
    }

    setAccountViral({ "reason_notify": userUsage?.automation_setting?.reason_notify || {} })
    setUserUsage({ "monthly_count": userUsage?.data?.monthly_count })

  }, [loadingUserUsage])

  const [userPlan, setUserPlan] = useState()
  const [userPlanLoading, setUserPlanLoading] = useState(true)

  const [postsLimitReached, setPostsLimitReached] = useState()
  const [postsAutomationLimit, setPostsAutomationLimit] = useState(
    AccessOrNot(
      "posts_automation",
      true,
      0,
      true)?.limit || "Unlimited"
  )


  const [allowMoreAutomation, setAllowMoreAutomation] = useState(true)

  const [nextPostsLimitReached, setNextPostsLimitReached] = useState()
  const [nextPostsAutomationLimit, setNextPostsAutomationLimit] = useState(
    AccessOrNot(
      "next_post_automation",
      true,
      0,
      true)?.limit || "Unlimited"
  )

  useEffect(() => {
    if (nextPostsAutomationLimit == "Unlimited") {
      setNextPostsAutomationLimit(100)
      return
    }

  }, [nextPostsAutomationLimit])

  useEffect(() => {
    if (data?.posts_lists?.data) {
      setNextPostsLimitReached(data?.posts_lists?.data?.length)

    }

  }, [data])



  useEffect(() => {
    if (postsLimitReached == undefined || postsAutomationLimit == "Unlimited") {
      return
    }
    if (postsLimitReached >= postsAutomationLimit) {
      setAllowMoreAutomation(false)
      messageApi.open({
        type: 'error',
        content: `You have reached your monthly limit of ${postsAutomationLimit} automations. Please upgrade your plan to continue.`,
        duration: 15,
        key: 3
      })
    }

  }, [postsLimitReached])

  useEffect(() => {

    setPostsLimitReached(Object.values(dataAutomatedFormated).filter(v => v === true).length)

  }, [dataAutomatedFormated])


  useEffect(() => {

    let tempData = {}
    if (dataAutomated["data"] == undefined) {
      return
    }

    dataAutomated["data"].map((item) => {
      if (item?.flow_editor == true) {
        tempData[item.post_id] = "flow_editor"
      }
      else {
        tempData[item.post_id] = item.automated_segment.length > 0 ? true : false
      }

    })

    setDataAutomatedFormated(tempData)
    let apiURL = `ig-usage-stat?tz=${user_tz}`
    callAPI({ url: apiURL, method: "GET", loadingState: setLoadingUserUsage, dataState: setUserUsage })

    let apiURL2 = `user_plan`
    callAPI({ url: apiURL2, method: "GET", loadingState: setUserPlanLoading, dataState: setUserPlan })



  }, [dataAutomated])


  useEffect(() => {

    if (userPlan == undefined) {
      return
    }
    if (userPlan?.data == undefined) {
      return
    }
    if (userPlan?.data != undefined) {
      let copy_data = { ...userPlan }

      let credit = Number(copy_data?.data?.plan_credits) + Number(copy_data?.data?.topup_credit)

      setTotalCredits(credit)


      let temp_plan_id = "428337"

      const date1Obj = new Date(userPlan.data.account_created);

      const date2Obj = new Date();

      const differenceInTime = date2Obj.getTime() - date1Obj.getTime();
      const differenceInDays = Math.floor(differenceInTime / (1000 * 3600 * 24));

      let current_plan_id = userPlan.data.plan_details.id



      if (differenceInDays < 8) {

        localStorage.setItem("og_planID", current_plan_id)
        current_plan_id = current_plan_id == "free" ? temp_plan_id : current_plan_id

        setTrailActive(differenceInDays)

      }
      localStorage.setItem("planid", current_plan_id)

      localStorage.setItem("founding_user", userPlan.data.founding_user)
      setUserPlan({ ...userPlan.data })

      return
    }

  }, [userPlan])

  useEffect(() => {
    messageApi.destroy(1)

    if (data != undefined && oldData.length < 1) {
      // On every inital load
      if (data.fb_api != undefined) { localStorage.setItem("fb_api", data.fb_api) }
      if (data.ig_api != undefined) { localStorage.setItem("ig_api", data.ig_api) }
    }

    if (oldData.length < 1 || data == undefined) {
      return
    }

    if (data?.code != 200) {
      setStatusError(true)
      return
    }
    if (data?.code == 200) {
      setStatusError(false)
    }

    let oldDataTemp = [...oldData]
    setOldData([])

    // console.log("=====DATATATA=====", data)
    if (data?.posts_lists?.error != undefined) {
      setPostsError(data.posts_lists.error.message)
    }

    if (data.posts_lists.data != undefined) {

      setData({ ...data, posts_lists: { ...data.posts_lists, data: [...oldDataTemp, ...data.posts_lists.data] } })
    }



    setStatusError(false)


  }, [data])

  useEffect(() => {
    if (loading == true) {
      return
    }
    if (loadMore == false) {
      return
    }
    messageApi.open({
      type: 'loading',
      content: 'Loading your posts',
      duration: 0,
      key: 1
    });

    let apiURL = ""

    if (selectedCategory == "posts") {
      apiURL = "ig-posts"
    }
    if (selectedCategory == "stories") {
      apiURL = "ig-stories"
    }

    if (selectedCategory == "next-post") {
      apiURL = "next-post"
    }
    // let old_data = []

    // console.log("API going to call")
    if (data?.posts_lists?.paging?.cursors?.after) {
      apiURL += `?after=${data?.posts_lists?.paging?.cursors?.after}`
      if (data.posts_lists.data != undefined) {
        setOldData([...data.posts_lists.data])
      }

    }

    callAPI({ url: apiURL, method: "GET", loadingState: setLoading, dataState: setData })

    if (dataAutomated.data == undefined) {
      let apiAutmatedURL = `automate-post`
      callAPI({ url: apiAutmatedURL, method: "GET", loadingState: setLoadingAutomated, dataState: setDataAutomated })
    }


    setLoadMore(false)


  }, [loadMore])

  useEffect(() => {

    setData()
    setLoadMore(loadMore == undefined ? true : undefined)


  }, [selectedCategory])


  const [paymentLinkData, setPaymentLinkData] = useState()
  const [paymentLinkLoading, setPaymentLinkLoading] = useState()

  const [showINR, setShowINR] = useState((user_tz == "Asia/Kolkata" || user_tz == "Asia/Calcutta") ? true : false)

  const [showWaitingPaymentUpdate, setShowWaitingPaymentUpdate] = useState(false)
  const [showWaitingPaymentFailed, setShowWaitingPaymentFailed] = useState(false)

  const [showWhatsNew, setShowWhatsNew] = useState(false)

  let release_id = "release_30122024"

  useEffect(() => {


    if (paymentLinkData?.open_url) {

      window.location.href = paymentLinkData?.payment_url
      return

    }

    if (paymentLinkData?.payment_url == undefined) {
      return
    }

    messageApi.destroy("payment-process")


    if (!showINR && window.LemonSqueezy) {
      const checkoutUrl = paymentLinkData.payment_url
      window.LemonSqueezy.Url.Open(checkoutUrl);
    }

    if (showINR && window.Razorpay) {

      try {

        const options = {
          key: "rzp_live_JtjGCHjkESNzIZ",
          name: "InstantDM",
          description: "Affordable Comment to DM automation tool",
          subscription_id: paymentLinkData.rzpy_sub_id, // Order ID from your server (generated by your backend)
          handler: function (response) {
            setShowPlanModal(false)
            setShowWaitingPaymentUpdate(true)

            message.success("Payment completed, Please wait while we're verfiying!")
            let user_detail = JSON.parse(localStorage.getItem("userData"))
            let igid = localStorage.getItem("ig_id")

            const BOT_TOKEN = "7109212238:AAEsaFubA66rs0Ib6rgn5K2amKO9rnOkUv0";
            const CHAT_ID = '776956029';
            const url = `https://api.telegram.org/bot${BOT_TOKEN}/sendMessage`;
            let tele_message = `[SUBSCRIBED PLAN] - user ${user_detail.emailid}  - Subscribed for  , IG ID = ${igid} , user id = ${user_detail.user_id}`
            let data = {
              chat_id: CHAT_ID,
              text: tele_message
            };


            fetch(url, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(data)
            })
              .then(response => response.json())
              .then(data => {
                console.log('Message sent successfully:', data);
              })
              .catch(error => {
                console.error('Error sending message:', error);
              });
            setPaymentLinkData({})




          },
          error: function (response) {
            setShowPlanModal(false)
            setShowWaitingPaymentFailed(true)
            setPaymentLinkData({})
            // alert("Payment Failed: " + response.error.description);
          },
          prefill: {
            name: paymentLinkData.customer_name,
            email: paymentLinkData.customer_email,
          },
          "notes": paymentLinkData.notes != undefined ? { ...paymentLinkData.notes } : {},
          theme: {
            color: "#1677ff",
          },
          display: {
            handler: function () {
              return {
                "offers": [
                  {
                    "type": "discount",
                    "description": "10% discount on first purchase",
                    "amount": 100
                  },
                  {
                    "type": "coupon",
                    "description": "Rs. 100 off on total bill",
                    "code": "INSTANT10"
                  }
                ]
              }
            }
          },
        };

        const razorpayInstance = new window.Razorpay(options);
        razorpayInstance.open();

      } catch (error) {
        alert("Error loading Razorpay: " + error.message);
      } finally {
        // setLoading(false);
      }

    }

    else {
      message.error("Please try again later...")
    }



  }, [paymentLinkData])

  function planContent() {

    if (userPlan == undefined) {
      return <p>Loading</p>
    }
    return (
      <div>

        <Statistic
          title="Plan credits"
          value={userPlan?.plan_credits}
          // precision={2}
          valueStyle={{
            color: 'black',
            fontWeight: '600'
          }} />

        <Statistic
          title="Topup credits"
          value={userPlan?.topup_credit}
          // precision={2}
          valueStyle={{
            color: 'black',
            fontWeight: '600'
          }} />

        {userPlan?.plan_details?.id == "free" && <Button type="primary" style={{ marginTop: '10px' }} onClick={() => { userPlan?.plan_details?.id == "free" && setShowPlanModal(true) }}>
          Upgrade to paid plan
        </Button>
        }

        {/* <Button type="primary" style={{marginTop:'10px'}} onClick={() => {userPlan?.plan_details?.id == "free" ? setShowPlanModal(true) : createPaymentLink("topup",messageApi, setPaymentLinkLoading, setPaymentLinkData) }}>
              { userPlan?.plan_details?.id == "free" ? "Upgrade to paid plan" : "Buy more credits"}
            </Button> */}

      </div>
    )
  }
  const [previewImage, setPreviewImage] = useState(null);
  const [previewOpen, setPreviewOpen] = useState(false);


  // console.log("========CREDIT=====" , totalCredits)
  return (
    <div className="page-layout">
      {contextHolder}

      <Sider />
      <div className="page-content">
        <Modal
          open={previewOpen}
          footer={null}
          onCancel={() => setPreviewOpen(false)}
          centered
          width="90vw"
          bodyStyle={{ padding: 0, background: "#000", textAlign: "center" }}
        >
          <img
            alt="Preview"
            src={previewImage}
            style={{ maxWidth: "100%", maxHeight: "80vh", margin: "auto", display: "block" }}
          />
        </Modal>

        {/* {localStorage.getItem(release_id) != "true" && <Alert
          message="🎉 See what's new !!! Followers only & Seprate Credits for stories automation and followers only."
          description=""
          type="info"
          style={{ marginBottom: '10px', marginTop: '10px' }}
          showIcon
          action={
            
             <Space direction="horizontal" size="large">
              
              <Button   type="primary" onClick={() => setShowWhatsNew(true)} >
                See what's new 🎉
              </Button>

              <Button size="small" danger ghost onClick={() => localStorage.setItem(release_id, "true")  }>
                Close
              </Button>
              
            </Space>
            
          }
        />

        } */}

        {/* <Alert
            message="Collect money from your audience inside instagram itself"
            description= "Introducing Cash Collect, you can sell your products, links, events,webinars and more"            
            style={{ marginBottom: '10px', marginTop: '10px' }}
            type="success"
            showIcon
            action={
              <Button size="large" type="primary" onClick={() => { setShowPlanModal(true) }}>
                Show Plans
              </Button>
            }

          /> */}

        {/* <Alert
          style={{ marginBottom: '10px', marginTop: '10px' }}
          message="🎉 Automate All DM's, All stories, All Posts and collect emails, phone number payments and more. Checkout our flow editor."
          description="Introducing InstantDM's flow editor(beta) , where you can collect email, phone number or any details you want. Also automate dm's, all stories, all posts with just one click."
          type="info"
          showIcon
          /> */}
        {showWaitingPaymentUpdate && <Alert
          message="Yay!! We have received your payment!"
          description="We have received your payment. Please give us a moment while we verify your payment details. Thank you."
          type="warning"
          style={{ marginBottom: '10px', marginTop: '10px' }}
          icon="🙏"
          showIcon
          closable
        />

        }
        {
          accountViral?.reason_notify?.title != undefined && !accountViral?.reason_notify?.title.includes("Message from Instagram") &&
          <Alert
            message={accountViral?.reason_notify?.title}
            description={accountViral?.reason_notify?.message}
            style={{ marginBottom: '10px', marginTop: '10px' }}
            type={accountViral?.reason_notify?.title.toLowerCase().includes("stopped") ? "error" : accountViral?.reason_notify?.title.toLowerCase().includes("viral") ? "success" : "info"}
            showIcon

          />
        }

        {showWaitingPaymentFailed && <Alert
          message="We're very sad that payment didn't go through well!"
          description="We have noticed that your payment was unsuccessful, please wait for sometime and try again, or contact our team for support, @instant.dm via instagram ."
          type="warning"
          style={{ marginBottom: '10px', marginTop: '10px' }}
          icon="🙏"
          showIcon
          closable
        />
        }

        {(userPlan?.sub_status != undefined && userPlan?.sub_status != "active" && userPlan?.plan_details?.id != "free") && <Alert
          message="Subscription Expired"
          description="Ohho no, you're supscription expired, please renew to continue"
          type="error"
          style={{ marginBottom: '10px', marginTop: '10px' }}
          action={
            <Button size="large" type="primary" onClick={() => { setShowPlanModal(true) }}>
              Renew Subscription
            </Button>
          }
          showIcon />
        }


        {(trailActive < 8 && userPlan?.plan_details?.id == "free") && <Alert
          message="7 Days Free Trail"
          description={`You're currently on 7 days free trail, and your free trail will exipre in ${7 - trailActive} days.`}

          style={{ marginBottom: '10px', marginTop: '10px' }}
          action={
            <div className="free-alert-btns">
              <Button style={{ marginRight: "10px" }} size="large" color="default" variant="solid" href="https://awake-morning-bb9.notion.site/InstantDM-Premium-access-Limited-Time-Offer-21e7409f565480d6b261ff11a62ada7c?source=copy_link">
                Extend Free Trail
              </Button>

              <Button size="large" type="primary" onClick={() => { setShowPlanModal(true) }}>
                Show Plans
              </Button>
            </div>
          }
          showIcon />
        }

        {(trailActive >= 8 && totalCredits != 0 && userPlan?.plan_details?.id == "free") && <Alert
          message="Free Plan"
          description="You're currently on free plan, click here to upgrade your plan."
          type="error"
          style={{ marginBottom: '10px', marginTop: '10px' }}
          action={
            <div className="free-alert-btns">
              <Button style={{ marginRight: "10px" }} size="large" color="default" variant="solid" href="https://awake-morning-bb9.notion.site/InstantDM-Premium-access-Limited-Time-Offer-21e7409f565480d6b261ff11a62ada7c?source=copy_link">
                Extend Free Trail
              </Button>

              <Button size="large" type="primary" onClick={() => { setShowPlanModal(true) }}>
                Show Plans
              </Button>
            </div>
          }
          showIcon />
        }

        {(totalCredits < 1 && userPlan?.plan_details?.id == "free") && <Alert
          message="Automation Stoped!"
          description="You have reached your monthly free usage limit. To continue using our automation services, please consider upgrading to a paid plan."
          type="error"
          style={{ marginBottom: '10px', marginTop: '10px' }}
          action={
            <div className="free-alert-btns">
              <Button style={{ marginRight: "10px" }} target="_blank" size="large" color="default" variant="solid" href="https://awake-morning-bb9.notion.site/InstantDM-Premium-access-Limited-Time-Offer-21e7409f565480d6b261ff11a62ada7c?source=copy_link">
                Extend Free Trail
              </Button>

              <Button size="large" type="primary" onClick={() => { setShowPlanModal(true) }}>
                Show Plans
              </Button>
            </div>
          }
          showIcon />
        }

        {/* {(totalCredits < 1 && userPlan?.plan_details?.id != "free") &&  <Alert
                  message="Automation Stoped!"
                  description="You have used all of your credits, please buy more credits to continue"
                  type="error"
                  style={{marginBottom:'10px', marginTop:'10px'}}
                  action={
                    <Button size="large" type="primary" onClick={() => {createPaymentLink("topup",messageApi, setPaymentLinkLoading, setPaymentLinkData)}}>
                      Buy Credits
                    </Button>
                  }
                  showIcon />
                } */}


        {(totalCredits < 1 && userPlan?.plan_details?.id != "free") && <Alert
          message="Automation Stoped!"
          description="We're stoked your account is getting more traction, but unfortunately, you've used up all your credits. Can you switch to a new plan so automation can start working again?"
          type="error"
          style={{ marginBottom: '10px', marginTop: '10px' }}
          action={
            <Button size="large" type="primary" onClick={() => { setShowPlanModal(true) }}>
              Show Plans
            </Button>
          }
          showIcon />
        }

        {userPlan?.plan_details?.id != "free" && <Alert
          message="💬 Love InstantDM? Share your feedback!"
          description="🌟 Help others discover InstantDM by leaving a quick review on G2. Your support means the world to us! 🙌"
          type="info"
          style={{ marginBottom: '10px', marginTop: '10px' }}
          icon={<CommentOutlined />}
          action={
            <div className="free-alert-btns">
              <Button style={{ marginRight: "10px" }} size="large" color="default" variant="solid" href="https://www.g2.com/products/instantdm/reviews" target="_blank">
                Share your feedback
              </Button>
            </div>
          }
          showIcon />}


        <div className="home-sec-1">

          <WhatsNew />

          <Tabs defaultActiveKey={default_tab} items={[

            {
              "key": "1",
              "label": "Quick Automation",
              children: <>
                <div className="mobile usage-content usage-content-mobile" style={{ marginTop: '0px' }}>
                  <Tooltip title="Automated Comments for This Month">

                    <Statistic
                      title="Monthly Automated"
                      value={userUsage.monthly_count || "Loading..."}
                      // precision={2}
                      valueStyle={{
                        color: 'black',
                        fontWeight: '600'

                      }}
                      style={{ width: '40%' }}
                    />


                  </Tooltip>
                  <div style={{ height: '80px', width: '2px', backgroundColor: 'grey', opacity: '.2' }} />

                  <Popover content={planContent} title="Credits Detail">

                    <Statistic title="Available credits" value={userPlan?.plan_credits != "unlimited" ? totalCredits : userPlan?.plan_credits} style={{ width: '40%' }} />

                  </Popover>



                </div>
                <div className="home-title-div">

                  <div className="title-content">
                    <h1 className="desktop">Quick Automate your posts</h1>

                  </div>
                  <>

                    {postsAutomationLimit != "Unlimited" &&
                      <div className="desktop usage-content" >
                        {/* style={{width:"400px"}}> */}


                        <Col style={{ marginTop: "-10px", width: "350px", overflowX: "scroll" }} className="hide-scrollbar">

                          <Flex align="center" justify="space-between" style={{ marginBottom: "10px", width: "100%" }}>
                            <h3 style={{ flex: 1, opacity: ".5", fontWeight: "500" }}>Automation remaining</h3>
                            <Button color="purple" variant="solid">Upgrade Plan</Button>
                          </Flex>
                          <Progress
                            percent={
                              (
                                postsLimitReached /
                                postsAutomationLimit *
                                100
                              ) || 0
                            }
                            steps={
                              postsAutomationLimit
                            }
                            strokeColor={
                              (() => {

                                const percent = (postsLimitReached / postsAutomationLimit) * 100;
                                if (percent >= 100) return "#ff4d4f"; // red
                                if (percent >= 60) return "#faad14"; // orange
                                return "#4f8cff"; // blue
                              })()
                            }
                            format={() => {

                              const left = Math.max(postsAutomationLimit - postsLimitReached, 0);
                              const percent = (postsLimitReached / postsAutomationLimit) * 100;
                              let color = "#4f8cff";
                              if (percent >= 100) color = "#ff4d4f";
                              else if (percent >= 60) color = "#faad14";
                              return (
                                <span style={{ color, fontWeight: 600 }}>
                                  {left} Automation remaining
                                </span>
                              );
                            }}
                          />
                          {/* <Progress  type="circle" percent={ (AccessOrNot("posts_automation" , true, Object.values(dataAutomatedFormated).filter(v => v === true).length, true )?.current_usage / AccessOrNot("posts_automation" , true, Object.values(dataAutomatedFormated).filter(v => v === true).length, true )?.limit) *100 } format={ percent => `${AccessOrNot("posts_automation" , true, Object.values(dataAutomatedFormated).filter(v => v === true).length, true )?.current_usage} / ${AccessOrNot("posts_automation" , true, Object.values(dataAutomatedFormated).filter(v => v === true).length, true )?.limit}`} /> */}

                        </Col>

                      </div>}

                    <div className="desktop usage-content" style={{ width: "auto" }}>


                      <Tooltip title="Automated Comments for This Month">

                        <Col>

                          <Statistic
                            title="Monthly Automated"
                            value={userUsage.monthly_count || "Loading..."}
                            // precision={2}
                            valueStyle={{
                              color: 'black',
                              fontWeight: '600'
                            }} />

                        </Col>


                      </Tooltip>

                      <div style={{ height: '80px', width: '2px', backgroundColor: 'grey', opacity: '.2' }} />

                      <Popover content={planContent} title="Credits Detail">
                        <Col>
                          <Statistic title="Available credits" value={userPlan?.plan_credits != "unlimited" ? totalCredits : userPlan?.plan_credits} />
                        </Col>

                      </Popover>

                    </div>
                  </>

                </div>
                <Segmented
                  style={{ marginBottom: '20px' }}
                  options={[
                    {
                      label: <p style={{ color: selectedCategory == "posts" ? "blue" : "black" }}><VideoCameraOutlined /> Posts </p>,
                      value: 'posts',
                    },
                    {
                      label: <p style={{ color: selectedCategory == "stories" ? "blue" : "black" }}><HistoryOutlined /> Stories </p>,
                      value: 'stories',
                    },
                    {
                      label: <p style={{ color: selectedCategory == "next-post" ? "blue" : "black" }}><PlusSquareOutlined /> Next Automation </p>,
                      value: 'next-post',
                    },
                  ]}

                  onChange={(value) => { setSelectedCategory(value) }}
                />


                {
                  data?.show_ig_connect == true &&

                  <Empty
                    style={{ marginBottom: '200px' }}
                    imageStyle={{
                      height: 60,
                    }}
                    description={
                      <p style={{ width: '60%', margin: '0 auto', fontSize: '16px' }}>
                        Reconnect your IG account to use this feature.
                        <br />
                      </p>
                    }
                  >

                    <a href="/ig-connect?show_ig_connect=true"><Button type="primary" danger> Re-connect Instagram account directly</Button></a>

                    <a href="/ig-connect"><Button type="primary" danger> Re-connect FB Page</Button></a>
                  </Empty>
                }
                <br />
                <Select
                  suffixIcon={<FilterTwoTone />}
                  defaultValue={filterPosts}
                  style={{ width: "80%", maxWidth: "300px", margin: "auto", marginBottom: "10px" }}
                  onChange={
                    (value) => setFilterPosts(value)
                  }
                  options={[
                    { value: 'all', label: 'All' },
                    { value: 'automated', label: 'Automated' },
                    { value: 'not_automated', label: 'Not Automated' },
                  ]}
                />

                {
                  (data?.posts_lists?.data != undefined && (data?.posts_lists?.data || []).length < 1) &&

                  <Empty
                    style={{ marginTop: '20px' }}
                    imageStyle={{
                      height: 60,
                    }}
                    description={
                      <p style={{ width: '60%', margin: '0 auto', fontSize: '16px' }}>
                        {selectedCategory == "stories" && `Looks like no active story posted!`}
                        {selectedCategory == "next-post" && `Looks like you haven't created any next automation.`}
                        {selectedCategory == "posts" && `Looks like no post published!`}
                        <br />
                      </p>
                    }
                  >

                  </Empty>
                }


                {
                  selectedCategory == "next-post" &&

                  <div style={{ marginBottom: '30px' }}>
                    <h1>Next post automation</h1>
                    <p style={{ opacity: '.6' }}>Automate your next post before uploading to Instagram! Save time, effort, and never lose engagement.</p>
                  </div>
                }

                {
                  (!AccessOrNot("next_post_automation") && selectedCategory == "next-post") && <Alert
                    message="Next post automation is not available in your plan"
                    description="Next post automation is available in our paid plans. Please upgrade your plan to use this feature."
                    type="error"
                    style={{ marginBottom: '10px', marginTop: '10px' }}
                    action={
                      <Button size="large" type="primary" onClick={() => { showPlanModal(true) }}>
                        Upgrade Plan
                      </Button>
                    } />
                }
                {
                  (AccessOrNot("next_post_automation") && data?.posts_lists?.data?.length > nextPostsAutomationLimit && selectedCategory == "next-post") && <Alert
                    message="Next post automation limit reached"
                    description={`You have reached the limit of ${nextPostsAutomationLimit} next post automations. Update your plan to increase the limit.`}
                    type="error"
                    style={{ marginBottom: '10px', marginTop: '10px' }}
                    action={
                      <Button size="large" type="primary" onClick={() => { showPlanModal(true) }}>
                        Update Plan
                      </Button>
                    }
                    showIcon />

                }

                {
                  (data?.posts_lists?.data != undefined && selectedCategory == "next-post") &&
                  <div className="posts-list" style={{ marginBottom: '60px' }}>

                    {
                      data["posts_lists"].data.length < nextPostsAutomationLimit &&
                      <Link style={{ textDecoration: 'none' }} key={data["posts_lists"].data.length > 0 ? Number(data["posts_lists"].data.at(-1).temp_post_id || "0") + 1 : 1} to={`/manage-post/${data["posts_lists"].data.length > 0 ? Number(data["posts_lists"].data.at(-1).temp_post_id || "0") + 1 : 1}?post_type=${selectedCategory}`}>
                        <div className="next-post-add">
                          <PlusCircleOutlined className="arrow-icon" />
                          <p>Create next post automation</p>
                        </div>
                      </Link>
                    }

                    {data?.posts_lists.data.map((post, index) =>
                      post.temp_post_id != undefined &&
                      <Link style={{ textDecoration: 'none' }} key={post.temp_post_id} to={`/manage-post/${post.temp_post_id}?post_type=${selectedCategory}`}>
                        <div className="next-post-add">
                          {index == 0 ? <StepForwardOutlined className="arrow-icon" /> : <FastForwardOutlined className="arrow-icon" />}
                          <p>{`Next post #${index + 1}`}</p>
                        </div>
                      </Link>

                    )}

                  </div>
                }



                {
                  (data?.posts_lists?.data != undefined && selectedCategory != "next-post") &&

                  <div className="posts-list">

                    {/* <Link style={{ textDecoration: 'none' }} key={"global"} to={`/manage-post/global?post_type=${selectedCategory}&flow_editor=${dataAutomatedFormated["global"] == "flow_editor"}`}>
                          <div className="post">
                          <img alt={"All post automation"} style={{ minWidth: '140px', maxWidth: '100%' }} className="thumbnil-img" src={`https://public-assets.instantdm.com/instantdm/all+posts+configuration.png`} crossorigin="anonymous" />

                          { dataAutomatedFormated["global"] == "flow_editor" &&
                            <div className="automate-label automated-via-flow">
                              <p> <BranchesOutlined /> Flow Editor</p>
                            </div>
                    }

                          { dataAutomatedFormated["global"] == true &&
                            <div className="automate-label automated">
                              <p>Automated</p>
                            </div>
                    }
                      { (dataAutomatedFormated["global"] != true  &&  dataAutomatedFormated["global"] != "flow_editor") &&
                              <div className="automate-label not-automated">
                                <p>Not Automated</p>
                              </div>
                      }
                        </div>
                        </Link> */}

                    {data["posts_lists"]["data"].map((post) => {

                      // console.log("-=-=-", dataAutomatedFormated[post.id])

                      if (filterPosts == "automated" && dataAutomatedFormated[post.id] != true) {
                        return
                      }
                      if (filterPosts == "not_automated" && dataAutomatedFormated[post.id] == true) {
                        return
                      }



                      return (
                        <Link style={{ textDecoration: 'none' }} key={post.id}
                          // to={`/manage-post/${post.id}?post_type=${selectedCategory}&flow_editor=${dataAutomatedFormated[post.id] == "flow_editor"}`}
                          to={
                            (dataAutomatedFormated[post.id] != true &&
                              dataAutomatedFormated[post.id] != "flow_editor" &&
                              allowMoreAutomation === false)
                              ? undefined
                              : `/manage-post/${post.id}?post_type=${selectedCategory}&flow_editor=${dataAutomatedFormated[post.id] == "flow_editor"}`
                          }
                          onClick={e => {
                            if (
                              dataAutomatedFormated[post.id] != true &&
                              dataAutomatedFormated[post.id] != "flow_editor" &&
                              allowMoreAutomation === false
                            ) {
                              e.preventDefault();
                              setShowPlanModal(true)

                            }

                          }}
                        >
                          <div className="post">
                            <img alt={post.caption} style={{ minWidth: '140px', maxWidth: '100%' }} className="thumbnil-img" src={`${post.thumbnail_url || post.media_url}`} crossorigin="anonymous" />

                            {dataAutomatedFormated[post.id] == "flow_editor" &&
                              <div className="automate-label automated-via-flow">
                                <p> <BranchesOutlined /> Flow Editor</p>
                              </div>
                            }

                            {dataAutomatedFormated[post.id] == true &&
                              <div className="automate-label automated">
                                <p>Automated</p>
                              </div>
                            }
                            {(dataAutomatedFormated[post.id] != true && dataAutomatedFormated[post.id] != "flow_editor") &&
                              <div className="automate-label not-automated">
                                <p>Not Automated</p>
                              </div>
                            }
                          </div>
                        </Link>)
                    })}
                    {
                      loadMore != true && (data?.posts_lists?.paging?.cursors?.after != undefined) &&
                      <div className="load-more" onClick={() => { setLoadMore(true) }}>
                        <RightCircleOutlined className="arrow-icon" />
                        <p>Load more</p>
                      </div>
                    }
                  </div>
                }

                {
                  // data?.fb_api != undefined && data?.fb_api != true  &&
                  (data?.fb_api != undefined && data?.fb_api != true && selectedCategory == "next-post") &&

                  <div className="fb-connect-card" style={{ marginBottom: '100px' }}>
                    <h1>To automatically map your next post, link your Instagram and Facebook pages. Once linked, connect your account by tapping the button below. Watch video for better understanding.</h1>
                    <a href="/ig-connect"> <Button type="primary" size="large" block>[Re]connect your FB page</Button> </a>
                    {/* <Button style={{marginTop:'20px'}} size="large" block>How this works, Watch 1 minute video.</Button> */}

                  </div>
                }

                {
                  selectedCategory == "next-post" &&

                  <iframe width="315" height="560"
                    style={{ margin: "0 auto" }}
                    src="https://www.youtube.com/embed/zIRW-Y3_ow0"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowfullscreen></iframe>


                }


                {(loading || loadMore && selectedCategory != "next-post") && <div className="posts-list">
                  {
                    Array(10).fill(0).map((_, index) => (
                      <Skeleton.Button
                        key={index}
                        style={{
                          width: 150,
                          height: 260,
                          borderRadius: '20px',
                          margin: '10px'
                        }}
                        active
                      />
                    ))
                  }
                </div>}

                {
                  (((data?.posts_lists == undefined || data?.posts_lists?.error != undefined) && loading == false) && selectedCategory != "next-post") &&

                  <Empty

                    imageStyle={{
                      height: 60,
                    }}
                    description={
                      <p style={{ width: '60%', margin: '0 auto', color: 'red', fontSize: '16px' }}>
                        Connect / Re-connect your IG account to continue automation.
                        <br />
                        <Collapse style={{ marginTop: '20px' }} items={[{ "key": 1, "label": "Click for more details", "children": <p>{data?.posts_lists?.error?.message || "Don't worry about your previous automation, the configuration are stored in secure way. Try reconnecting your account."}</p> }]} />
                      </p>


                    }
                  >
                    <div style={{ display: 'flex', width: '30%', minWidth: '240px', maxWidth: '90%', margin: '0 auto', flexDirection: 'column', 'gap': '20px', alignContent: 'center', justifyContent: 'center', paddingBottom: '60px' }}>
                      <a href="/ig-connect?show_ig_connect=true"><Button type="primary" danger> Re-connect your IG account</Button></a>
                      {/* <Button type="primary"> <Link to="/oia">Use Open in Link / URL Shortner </Link> </Button> */}
                    </div>
                  </Empty>
                }


              </>
            },

            {
              "key": "3",
              "label": <p>Flow Automation - DM & Global automation</p>,
              "children": <AutomationList />
            },

          ]} />



        </div>

      </div>


      {/* <a className="mobile" target="_blank" href="https://instagram.com/instant.dm">
      <FloatButton type="primary" shape="square" style={{ width:"100px" , padding:"10px",bottom:"100px"}} icon={<InstagramOutlined />} description="Chat with us" >
      </FloatButton>
      </a> */}

      {/* <a className="desktop" target="_blank" href="https://instagram.com/instant.dm">
      <FloatButton type="primary" shape="square" style={{ width:"100px" , padding:"10px", bottom:"50px"}} icon={<InstagramOutlined />} description="Chat with us" >
      </FloatButton>
      </a> */}


      <Modal
        title="Plans"
        open={showPlanModal}
        onCancel={() => setShowPlanModal(false)}
        width='100%'
      // maxWidth='800px'
      >


        <ShowPlans messageApi={messageApi} setPaymentLinkLoading={setPaymentLinkLoading} setPaymentLinkData={setPaymentLinkData} currentPlan={localStorage.getItem("planid")} />
      </Modal>




    </div>
  )

}
export default Home;
